export const templateLandingCopy = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Nemonto — You're invited to the table</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30;
    --spice-deep:#B23D18;
    --cream:#FAECE7;
    --peach:#F5C4B3;
    --charcoal:#2C2C2A;
    --herb:#1D9E75;
    --gold:#FAC775;
    --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif;
    --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  html{scroll-behavior:smooth;}
  body{
    background:var(--cream);
    color:var(--charcoal);
    font-family:var(--sans);
    overflow-x:hidden;
  }
  a{color:inherit; text-decoration:none;}
  img,svg{display:block;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:3px; border-radius:4px;}

  .wrap{max-width:1180px; margin:0 auto; padding:0 28px;}

  /* ---------- NAV ---------- */
  nav{
    position:sticky; top:0; z-index:50;
    background:rgba(250,236,231,0.88);
    backdrop-filter:blur(10px);
    border-bottom:1px solid rgba(44,44,42,0.08);
  }
  .nav-inner{
    display:flex; align-items:center; justify-content:space-between;
    padding:16px 28px; max-width:1180px; margin:0 auto;
  }
  .logo{display:flex; align-items:center; gap:8px; font-family:var(--serif); font-size:22px; color:var(--charcoal);}
  .logo img{height:34px; width:auto; display:block;}
  .nav-links{display:flex; align-items:center; gap:34px;}
  .nav-links a{font-size:14px; font-weight:500; color:var(--charcoal); opacity:0.78; transition:opacity .15s;}
  .nav-links a:hover{opacity:1;}
  .nav-cta{
    background:var(--spice); color:var(--cream); padding:10px 20px;
    border-radius:30px; font-size:13.5px; font-weight:600;
    transition:transform .18s ease, box-shadow .18s ease;
  }
  .nav-cta:hover{transform:translateY(-1px); box-shadow:0 8px 20px rgba(216,90,48,0.32);}
  .nav-toggle{display:none;}

  /* ---------- HERO ---------- */
  .hero{
    position:relative;
    padding:96px 0 64px;
    overflow:hidden;
  }
  .steam-bg{
    position:absolute; top:-120px; right:-160px; width:640px; height:640px;
    background:radial-gradient(circle at 40% 40%, rgba(216,90,48,0.16), transparent 70%);
    pointer-events:none;
  }
  .hero-grid{
    display:grid; grid-template-columns:1.05fr 0.95fr; gap:56px; align-items:center;
    position:relative; z-index:1;
  }
  .eyebrow{
    display:inline-flex; align-items:center; gap:8px;
    font-size:12.5px; font-weight:600; letter-spacing:0.07em; text-transform:uppercase;
    color:var(--spice-deep); background:rgba(216,90,48,0.1);
    padding:7px 14px; border-radius:30px; margin-bottom:22px;
  }
  .eyebrow .dot{width:6px; height:6px; border-radius:50%; background:var(--spice); animation:pulse 1.8s infinite;}
  @keyframes pulse{0%,100%{opacity:1;} 50%{opacity:0.35;}}

  h1.hero-title{
    font-family:var(--serif); font-size:clamp(42px, 5.4vw, 68px); line-height:1.04;
    color:var(--charcoal); letter-spacing:-0.01em; margin-bottom:22px;
  }
  h1.hero-title em{
    font-style:italic; color:var(--spice); display:inline-block; position:relative;
  }
  .hero-sub{
    font-size:18px; line-height:1.6; color:#5A4F49; max-width:480px; margin-bottom:34px;
  }
  .hero-ctas{display:flex; gap:14px; flex-wrap:wrap; margin-bottom:38px;}
  .btn-primary{
    background:var(--spice); color:var(--cream); padding:15px 28px; border-radius:32px;
    font-size:15px; font-weight:600; display:inline-flex; align-items:center; gap:8px;
    border:none; cursor:pointer; transition:transform .18s ease, box-shadow .18s ease;
  }
  .btn-primary:hover{transform:translateY(-2px); box-shadow:0 12px 26px rgba(216,90,48,0.34);}
  .btn-ghost{
    background:transparent; color:var(--charcoal); padding:15px 26px; border-radius:32px;
    font-size:15px; font-weight:600; border:1.5px solid rgba(44,44,42,0.18);
    display:inline-flex; align-items:center; gap:8px; cursor:pointer; transition:border-color .18s, background .18s;
  }
  .btn-ghost:hover{border-color:var(--charcoal); background:rgba(44,44,42,0.04);}

  .hero-proof{display:flex; align-items:center; gap:14px;}
  .avatars{display:flex;}
  .avatars span{
    width:34px; height:34px; border-radius:50%; border:2.5px solid var(--cream);
    margin-left:-10px; display:block;
  }
  .avatars span:first-child{margin-left:0;}
  .hero-proof p{font-size:13.5px; color:#5A4F49;}
  .hero-proof strong{color:var(--charcoal);}

  /* hero visual: bowl + table card stack */
  .hero-visual{position:relative; height:480px;}
  .bowl-hero{position:absolute; top:0; right:30px; width:230px; z-index:2;}
  .card-float{
    position:absolute; background:#fff; border-radius:18px;
    box-shadow:0 24px 48px -12px rgba(44,28,18,0.22);
    padding:14px; width:208px;
  }
  .card-float .thumb{
    width:100%; height:108px; border-radius:12px; margin-bottom:10px;
    display:flex; align-items:center; justify-content:center;
  }
  .card-float .label{font-family:var(--serif); font-size:15px; color:var(--charcoal); margin-bottom:4px; line-height:1.25;}
  .card-float .meta{font-size:11.5px; color:#9A8C84; display:flex; align-items:center; gap:6px;}
  .card-1{top:64px; left:0; transform:rotate(-6deg); animation:float1 7s ease-in-out infinite;}
  .card-2{bottom:18px; left:60px; transform:rotate(4deg); z-index:1; animation:float2 8s ease-in-out infinite;}
  .badge-made{
    position:absolute; top:280px; right:0; background:var(--charcoal); color:var(--cream);
    padding:10px 16px; border-radius:14px; font-size:12.5px; font-weight:500;
    display:flex; align-items:center; gap:8px; box-shadow:0 14px 30px rgba(44,28,18,0.28);
    animation:float3 6s ease-in-out infinite;
  }
  @keyframes float1{0%,100%{transform:rotate(-6deg) translateY(0);} 50%{transform:rotate(-6deg) translateY(-10px);}}
  @keyframes float2{0%,100%{transform:rotate(4deg) translateY(0);} 50%{transform:rotate(4deg) translateY(-8px);}}
  @keyframes float3{0%,100%{transform:translateY(0);} 50%{transform:translateY(-6px);}}

  @media (prefers-reduced-motion: reduce){
    .card-1,.card-2,.badge-made,.eyebrow .dot{animation:none;}
  }

  /* ---------- LOGO STRIP ---------- */
  .logo-strip{padding:34px 0; border-top:1px solid rgba(44,44,42,0.08); border-bottom:1px solid rgba(44,44,42,0.08);}
  .logo-strip-inner{display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:20px;}
  .logo-strip p{font-size:12.5px; color:#9A8C84; font-weight:600; letter-spacing:0.05em; text-transform:uppercase; white-space:nowrap;}
  .cuisine-row{display:flex; gap:28px; flex-wrap:wrap;}
  .cuisine-row span{font-family:var(--serif); font-size:17px; color:#C9897A; font-style:italic;}

  /* ---------- THE TABLE (signature horizontal scroll) ---------- */
  .table-section{padding:108px 0 70px;}
  .section-head{max-width:600px; margin-bottom:54px;}
  .section-kicker{font-size:12.5px; font-weight:700; letter-spacing:0.08em; text-transform:uppercase; color:var(--spice); margin-bottom:14px; display:block;}
  .section-title{font-family:var(--serif); font-size:clamp(30px,3.6vw,42px); line-height:1.16; color:var(--charcoal); margin-bottom:16px;}
  .section-title em{color:var(--spice); font-style:italic;}
  .section-desc{font-size:16px; color:#5A4F49; line-height:1.6;}

  .table-rail{
    position:relative;
  }
  .table-line{
    position:absolute; left:0; right:0; top:128px; height:2px;
    background:repeating-linear-gradient(to right, rgba(44,44,42,0.18) 0 10px, transparent 10px 20px);
    z-index:0;
  }
  .table-scroll{
    display:flex; gap:22px; overflow-x:auto; padding:6px 28px 28px;
    scroll-snap-type:x proximity; position:relative; z-index:1;
    margin:0 -28px;
  }
  .table-scroll::-webkit-scrollbar{height:6px;}
  .table-scroll::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.18); border-radius:10px;}
  .place-card{
    flex:0 0 264px; background:#fff; border-radius:20px; padding:18px; scroll-snap-align:start;
    box-shadow:0 18px 40px -16px rgba(44,28,18,0.16);
    display:flex; flex-direction:column; gap:12px;
    transition:transform .2s ease, box-shadow .2s ease;
  }
  .place-card:hover{transform:translateY(-6px); box-shadow:0 26px 50px -16px rgba(44,28,18,0.24);}
  .place-thumb{height:148px; border-radius:14px; position:relative; overflow:hidden; display:flex; align-items:center; justify-content:center;}
  .steam-icon{position:relative; z-index:1;}
  .place-card .top-row{display:flex; align-items:center; gap:8px;}
  .place-card .avatar{width:26px; height:26px; border-radius:50%; flex-shrink:0;}
  .place-card .who{font-size:12px; color:#9A8C84;}
  .place-card .who b{color:var(--charcoal); font-weight:600;}
  .place-card .dish{font-family:var(--serif); font-size:18px; color:var(--charcoal); line-height:1.28;}
  .place-card .stats{display:flex; gap:14px; font-size:12px; color:#9A8C84; align-items:center;}
  .place-card .stats b{color:var(--spice-deep); font-weight:700;}
  .made-pill{
    align-self:flex-start; background:var(--cream); color:var(--spice-deep); font-size:11.5px; font-weight:700;
    padding:5px 11px; border-radius:20px; border:1px solid rgba(216,90,48,0.22);
  }

  /* ---------- HOW IT WORKS ---------- */
  .how{padding:64px 0 108px;}
  .how-grid{display:grid; grid-template-columns:repeat(3,1fr); gap:28px;}
  .how-card{
    background:#fff; border-radius:22px; padding:32px 26px;
    border:1px solid rgba(44,44,42,0.06);
  }
  .how-icon{
    width:52px; height:52px; border-radius:16px; display:flex; align-items:center; justify-content:center;
    margin-bottom:22px;
  }
  .how-card h3{font-family:var(--serif); font-size:21px; margin-bottom:10px; color:var(--charcoal);}
  .how-card p{font-size:14.5px; color:#6B5F58; line-height:1.6;}
  .how-step{font-size:12px; font-weight:700; color:var(--spice); letter-spacing:0.06em; text-transform:uppercase; margin-bottom:14px; display:block;}

  /* ---------- CHALLENGES (full section) ---------- */
  .challenges-section{background:var(--charcoal); padding:108px 0; position:relative; overflow:hidden;}
  .challenges-section::before{
    content:''; position:absolute; top:-160px; left:-120px; width:420px; height:420px;
    background:radial-gradient(circle, rgba(216,90,48,0.30), transparent 70%); pointer-events:none;
  }
  .challenges-section::after{
    content:''; position:absolute; bottom:-180px; right:-140px; width:420px; height:420px;
    background:radial-gradient(circle, rgba(250,199,117,0.14), transparent 70%); pointer-events:none;
  }
  .challenges-section .section-head{position:relative; z-index:1; margin-bottom:60px;}
  .challenges-section .section-kicker{color:var(--gold);}
  .challenges-section .section-title{color:var(--cream);}
  .challenges-section .section-title em{color:var(--gold);}
  .challenges-section .section-desc{color:rgba(250,236,231,0.68);}

  .challenge-banner{
    display:grid; grid-template-columns:1fr 1fr; gap:48px; align-items:center;
    position:relative; z-index:1; margin-bottom:64px;
  }
  .challenge-banner .eyebrow{background:rgba(250,199,117,0.16); color:var(--gold); margin-bottom:18px;}
  .challenge-banner .eyebrow .dot{background:var(--gold);}
  .challenge-banner h3{font-family:var(--serif); font-size:clamp(26px,3vw,34px); color:var(--cream); line-height:1.22; margin-bottom:16px;}
  .challenge-banner h3 em{color:var(--gold); font-style:italic;}
  .challenge-banner p{font-size:15.5px; color:rgba(250,236,231,0.72); line-height:1.65; margin-bottom:28px; max-width:440px;}
  .challenge-list{display:flex; flex-direction:column; gap:14px; margin-bottom:30px;}
  .challenge-list-item{display:flex; gap:12px; align-items:flex-start;}
  .check-circle{
    width:22px; height:22px; border-radius:50%; background:rgba(250,199,117,0.18);
    display:flex; align-items:center; justify-content:center; flex-shrink:0; margin-top:1px;
  }
  .challenge-list-item p{font-size:14px; color:rgba(250,236,231,0.85); margin:0; max-width:none;}
  .challenge-visual{
    background:linear-gradient(160deg, #3a3531, #232020);
    border-radius:22px; padding:22px; position:relative; z-index:1;
    border:1px solid rgba(250,236,231,0.08);
  }
  .live-pill{
    display:inline-flex; align-items:center; gap:6px; background:var(--spice); color:#fff;
    font-size:11px; font-weight:700; padding:5px 11px; border-radius:20px; margin-bottom:14px;
  }
  .live-pill .dot{width:6px; height:6px; border-radius:50%; background:#fff;}
  .challenge-visual .ctitle{font-family:var(--serif); font-size:20px; color:var(--cream); margin-bottom:10px; line-height:1.3;}
  .ingredient-chips{display:flex; gap:6px; flex-wrap:wrap; margin-bottom:18px;}
  .ingredient-chips span{
    background:rgba(250,236,231,0.1); color:var(--cream); font-size:11.5px;
    padding:5px 10px; border-radius:20px;
  }
  .cv-stats{display:flex; gap:10px;}
  .cv-stat{flex:1; background:rgba(250,236,231,0.07); border-radius:12px; padding:10px; text-align:center;}
  .cv-stat b{display:block; font-size:16px; color:var(--gold); font-family:var(--serif);}
  .cv-stat span{font-size:10.5px; color:rgba(250,236,231,0.6);}

  /* challenge step row */
  .challenge-steps{position:relative; z-index:1; display:grid; grid-template-columns:repeat(3,1fr); gap:24px; margin-bottom:64px;}
  .cstep-card{
    background:rgba(250,236,231,0.05); border:1px solid rgba(250,236,231,0.1); border-radius:20px;
    padding:28px 24px;
  }
  .cstep-num{
    width:34px; height:34px; border-radius:50%; background:rgba(250,199,117,0.16); color:var(--gold);
    display:flex; align-items:center; justify-content:center; font-family:var(--serif); font-size:15px;
    margin-bottom:18px;
  }
  .cstep-card h4{font-family:var(--serif); font-size:18px; color:var(--cream); margin-bottom:8px;}
  .cstep-card p{font-size:13.5px; color:rgba(250,236,231,0.62); line-height:1.6;}

  /* winner board */
  .winner-board{
    position:relative; z-index:1; background:rgba(250,236,231,0.05); border:1px solid rgba(250,236,231,0.1);
    border-radius:24px; padding:32px; display:grid; grid-template-columns:1fr auto; gap:24px; align-items:center;
  }
  .winner-board-left{display:flex; align-items:center; gap:16px;}
  .winner-avatar{
    width:56px; height:56px; border-radius:50%; background:#9FE1CB; flex-shrink:0;
    border:2.5px solid var(--gold); position:relative;
  }
  .winner-crown{position:absolute; top:-12px; right:-6px; font-size:18px;}
  .winner-board-left h5{font-family:var(--serif); font-size:18px; color:var(--cream); margin-bottom:4px;}
  .winner-board-left p{font-size:13px; color:rgba(250,236,231,0.6); margin:0;}
  .winner-board-left p span{color:var(--gold); font-weight:600;}
  .winner-cta{background:var(--gold); color:#3A2A0A; padding:12px 22px; border-radius:30px; font-size:14px; font-weight:700; white-space:nowrap;}

  /* ---------- FOUNDING CREATOR ---------- */
  .creator-section{padding:108px 0;}
  .creator-grid{display:grid; grid-template-columns:0.9fr 1.1fr; gap:60px; align-items:center;}
  .cert-mock{
    background:var(--charcoal); border-radius:24px; padding:40px 32px; text-align:center;
    position:relative; box-shadow:0 30px 60px -20px rgba(44,28,18,0.35);
  }
  .cert-mock .ctop{font-size:11px; letter-spacing:0.12em; text-transform:uppercase; color:var(--spice); margin-bottom:14px;}
  .cert-mock .cbowl{margin:0 auto 18px;}
  .cert-mock .cname{font-family:var(--serif); font-size:24px; color:var(--gold); font-style:italic; margin-bottom:6px;}
  .cert-mock .csub{font-size:12px; color:rgba(250,236,231,0.55); line-height:1.6; margin-bottom:18px;}
  .cert-mock .cbadge{
    display:inline-block; background:var(--spice); color:var(--cream); font-size:12px; font-weight:700;
    padding:7px 16px; border-radius:20px;
  }
  .creator-copy ul{list-style:none; display:flex; flex-direction:column; gap:16px; margin:28px 0 32px;}
  .creator-copy li{display:flex; gap:12px; font-size:14.5px; color:#5A4F49; line-height:1.5;}
  .creator-copy li b{color:var(--charcoal);}

  /* ---------- TESTIMONIAL STRIP ---------- */
  .quote-section{background:var(--peach); padding:90px 0;}
  .quote-grid{display:grid; grid-template-columns:repeat(3,1fr); gap:28px;}
  .quote-card{background:rgba(255,255,255,0.55); border-radius:20px; padding:28px;}
  .quote-card p.q{font-family:var(--serif); font-size:18px; line-height:1.45; color:var(--charcoal); margin-bottom:18px; font-style:italic;}
  .qwho{display:flex; align-items:center; gap:10px;}
  .qwho .avatar{width:36px; height:36px; border-radius:50%;}
  .qwho .name{font-size:13.5px; font-weight:600; color:var(--charcoal);}
  .qwho .tag{font-size:12px; color:#8A6F62;}

  /* ---------- FINAL CTA ---------- */
  .final-cta{padding:120px 0 100px; text-align:center; position:relative;}
  .final-cta h2{font-family:var(--serif); font-size:clamp(34px,5vw,58px); color:var(--charcoal); line-height:1.1; max-width:760px; margin:0 auto 22px;}
  .final-cta h2 em{color:var(--spice); font-style:italic;}
  .final-cta p{font-size:17px; color:#5A4F49; max-width:480px; margin:0 auto 38px;}
  .store-row{display:flex; gap:14px; justify-content:center; flex-wrap:wrap;}
  .store-btn{
    display:flex; align-items:center; gap:10px; background:var(--charcoal); color:var(--cream);
    padding:13px 24px; border-radius:14px; font-size:14px; transition:transform .18s;
  }
  .store-btn:hover{transform:translateY(-2px);}
  .store-btn small{display:block; font-size:10px; color:rgba(250,236,231,0.6);}
  .store-btn strong{font-size:14.5px; font-weight:600;}

  /* ---------- FOOTER ---------- */
  footer{background:var(--charcoal); color:rgba(250,236,231,0.7); padding:64px 0 32px;}
  .footer-grid{display:grid; grid-template-columns:1.4fr 1fr 1fr 1fr; gap:40px; margin-bottom:48px;}
  .footer-logo{margin-bottom:14px;}
  .footer-logo img{height:34px; width:auto; display:block;}
  .footer-grid p.tag{font-size:13.5px; line-height:1.6; max-width:260px; color:rgba(250,236,231,0.55);}
  .footer-col h4{font-size:12px; letter-spacing:0.06em; text-transform:uppercase; color:rgba(250,236,231,0.45); margin-bottom:16px;}
  .footer-col a{display:block; font-size:14px; margin-bottom:11px; color:rgba(250,236,231,0.78); transition:color .15s;}
  .footer-col a:hover{color:var(--gold);}
  .footer-bottom{
    border-top:1px solid rgba(250,236,231,0.1); padding-top:24px;
    display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:14px;
    font-size:12.5px; color:rgba(250,236,231,0.45);
  }

  /* ---------- RESPONSIVE ---------- */
  @media (max-width: 980px){
    .hero-grid{grid-template-columns:1fr; gap:60px;}
    .hero-visual{height:380px; max-width:420px; margin:0 auto; width:100%;}
    .how-grid{grid-template-columns:1fr; }
    .challenge-steps{grid-template-columns:1fr;}
    .challenge-banner{grid-template-columns:1fr;}
    .winner-board{grid-template-columns:1fr; text-align:center;}
    .winner-board-left{flex-direction:column; text-align:center;}
    .creator-grid{grid-template-columns:1fr; gap:36px;}
    .cert-mock{max-width:320px; margin:0 auto;}
    .quote-grid{grid-template-columns:1fr;}
    .footer-grid{grid-template-columns:1fr 1fr; gap:32px;}
  }
  @media (max-width: 720px){
    .nav-links{display:none;}
    .wrap{padding:0 20px;}
    .hero{padding:48px 0 40px;}
    h1.hero-title{font-size:38px;}
    .footer-grid{grid-template-columns:1fr;}
  }
</style>
</head>
<body>

<!-- ================= NAV ================= -->
<nav>
  <div class="nav-inner">
    <div class="logo">
      <img src="/image/nemonto-logo.png" alt="Nemonto" />
    </div>
    <div class="nav-links">
      <a href="#table">For foodies</a>
      <a href="#challenges">Challenges</a>
      <a href="#creators">For creators</a>
      <a href="#stories">Stories</a>
    </div>
    <a href="#get" class="nav-cta">Get the app</a>
  </div>
</nav>

<!-- ================= HERO ================= -->
<header class="hero">
  <div class="steam-bg"></div>
  <div class="wrap hero-grid">
    <div>
      <span class="eyebrow"><span class="dot"></span>Now seating in New York City</span>
      <h1 class="hero-title">You're invited<br>to <em>the table.</em></h1>
      <p class="hero-sub">Nemonto comes from a Bengali word for dinner invitation. Post the recipe. Someone cooks it. They post their version back. That's the whole app — and it's more fun than it sounds.</p>
      <div class="hero-ctas">
        <a href="#get" class="btn-primary">
          Accept the invitation
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </a>
        <a href="#table" class="btn-ghost">See it in action</a>
      </div>
      <div class="hero-proof">
        <div class="avatars">
          <span style="background:#F0997B"></span>
          <span style="background:#9FE1CB"></span>
          <span style="background:#AFA9EC"></span>
          <span style="background:#FAC775"></span>
        </div>
        <p><strong>300+ home cooks</strong> already pulled up a chair</p>
      </div>
    </div>

    <div class="hero-visual" aria-hidden="true">
      <svg class="bowl-hero" viewBox="0 0 230 230" width="230" height="230">
        <ellipse cx="115" cy="172" rx="68" ry="13" fill="#993C1D" opacity="0.28"/>
        <path d="M44 122 Q44 192 115 192 Q186 192 186 122 Z" fill="#D85A30"/>
        <path d="M40 116 Q40 132 52 132 L178 132 Q190 132 190 116 Q190 92 115 92 Q40 92 40 116 Z" fill="#FAECE7"/>
        <path d="M76 76 Q68 56 76 36" stroke="#FAC775" stroke-width="6" fill="none" stroke-linecap="round"/>
        <path d="M115 68 Q107 48 115 28" stroke="#FAC775" stroke-width="6" fill="none" stroke-linecap="round"/>
        <path d="M154 76 Q146 56 154 36" stroke="#FAC775" stroke-width="6" fill="none" stroke-linecap="round"/>
      </svg>

      <div class="card-float card-1">
        <div class="thumb" style="background:linear-gradient(135deg,#F0997B,#D85A30);">
          <svg width="40" height="40" viewBox="0 0 100 100" aria-hidden="true"><ellipse cx="50" cy="74" rx="30" ry="6" fill="#993C1D" opacity="0.4"/><path d="M20 50 Q20 78 50 78 Q80 78 80 50 Z" fill="#fff" opacity="0.85"/><path d="M18 47 Q18 53 23 53 L77 53 Q82 53 82 47 Q82 38 50 38 Q18 38 18 47 Z" fill="#fff"/></svg>
        </div>
        <p class="label">Cacio e Pepe — nonna's version</p>
        <p class="meta">by Maria K. · 47 made it</p>
      </div>

      <div class="card-float card-2">
        <div class="thumb" style="background:linear-gradient(135deg,#9FE1CB,#1D9E75);">
          <svg width="40" height="40" viewBox="0 0 100 100" aria-hidden="true"><circle cx="35" cy="42" r="9" fill="#fff" opacity="0.9"/><circle cx="56" cy="38" r="7" fill="#fff" opacity="0.7"/><circle cx="63" cy="52" r="6" fill="#fff" opacity="0.6"/></svg>
        </div>
        <p class="label">Dal Tadka with ghee drizzle</p>
        <p class="meta">by Priya R. · 89 ♥</p>
      </div>

      <div class="badge-made">
        🔥 Nailed it — posted 2 min ago
      </div>
    </div>
  </div>
</header>

<!-- ================= CUISINE STRIP ================= -->
<section class="logo-strip">
  <div class="wrap logo-strip-inner">
    <p>Every table has a seat for</p>
    <div class="cuisine-row">
      <span>Bengali</span><span>Italian</span><span>South Asian</span><span>Mexican</span><span>BBQ</span><span>French</span><span>East Asian</span>
    </div>
  </div>
</section>

<!-- ================= THE TABLE ================= -->
<section class="table-section" id="table">
  <div class="wrap">
    <div class="section-head">
      <span class="section-kicker">The feed</span>
      <h2 class="section-title">Pull up a chair.<br>Everyone's <em>cooking something.</em></h2>
      <p class="section-desc">No filters, no algorithm games — just recipes from real people, and proof that someone else actually made them.</p>
    </div>
  </div>

  <div class="table-rail">
    <div class="table-line"></div>
    <div class="table-scroll">

      <div class="place-card">
        <div class="top-row"><div class="avatar" style="background:#F0997B"></div><p class="who"><b>Maria K.</b> · Italian</p></div>
        <div class="place-thumb" style="background:linear-gradient(150deg,#E8916F,#B23D18);">
          <svg class="steam-icon" width="54" height="54" viewBox="0 0 100 100"><ellipse cx="50" cy="76" rx="32" ry="6" fill="#7A2A0A" opacity="0.4"/><path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.9"/><path d="M16 47 Q16 53 21 53 L79 53 Q84 53 84 47 Q84 38 50 38 Q16 38 16 47 Z" fill="#fff"/></svg>
        </div>
        <p class="dish">Cacio e Pepe — nonna's version</p>
        <div class="stats">⏱ 15 min &nbsp;·&nbsp; <b>47</b> made it</div>
        <span class="made-pill">🔥 47 nailed it</span>
      </div>

      <div class="place-card">
        <div class="top-row"><div class="avatar" style="background:#9FE1CB"></div><p class="who"><b>Priya R.</b> · South Asian</p></div>
        <div class="place-thumb" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
          <svg class="steam-icon" width="54" height="54" viewBox="0 0 100 100"><ellipse cx="50" cy="55" rx="28" ry="8" fill="#085041" opacity="0.4"/><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.9"/><circle cx="58" cy="40" r="8" fill="#fff" opacity="0.7"/><circle cx="64" cy="54" r="6" fill="#fff" opacity="0.6"/></svg>
        </div>
        <p class="dish">Dal Tadka with ghee drizzle</p>
        <div class="stats">⏱ 25 min &nbsp;·&nbsp; <b>89</b> made it</div>
        <span class="made-pill">🔄 12 made it their own</span>
      </div>

      <div class="place-card">
        <div class="top-row"><div class="avatar" style="background:#AFA9EC"></div><p class="who"><b>James L.</b> · BBQ</p></div>
        <div class="place-thumb" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
          <svg class="steam-icon" width="54" height="54" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.5"/><rect x="28" y="24" width="44" height="13" rx="6" fill="#fff" opacity="0.75"/></svg>
        </div>
        <p class="dish">Low-and-slow smoked brisket</p>
        <div class="stats">⏱ 8 hr &nbsp;·&nbsp; <b>34</b> made it</div>
        <span class="made-pill">🏆 Challenge winner</span>
      </div>

      <div class="place-card">
        <div class="top-row"><div class="avatar" style="background:#FAC775"></div><p class="who"><b>Sofia M.</b> · Bakery</p></div>
        <div class="place-thumb" style="background:linear-gradient(150deg,#FCD58E,#BA7517);">
          <svg class="steam-icon" width="54" height="54" viewBox="0 0 100 100"><ellipse cx="50" cy="60" rx="30" ry="10" fill="#7A4E08" opacity="0.3"/><path d="M24 48 Q24 70 50 70 Q76 70 76 48 Z" fill="#fff" opacity="0.85"/></svg>
        </div>
        <p class="dish">Rosemary sourdough, no knead</p>
        <div class="stats">⏱ 18 hr &nbsp;·&nbsp; <b>61</b> made it</div>
        <span class="made-pill">😅 22 almost got it</span>
      </div>

      <div class="place-card">
        <div class="top-row"><div class="avatar" style="background:#F5C4B3"></div><p class="who"><b>Chen W.</b> · East Asian</p></div>
        <div class="place-thumb" style="background:linear-gradient(150deg,#E8693D,#993C1D);">
          <svg class="steam-icon" width="54" height="54" viewBox="0 0 100 100"><circle cx="50" cy="50" r="28" fill="#fff" opacity="0.3"/><circle cx="50" cy="50" r="16" fill="#fff" opacity="0.55"/><circle cx="50" cy="50" r="6" fill="#fff" opacity="0.9"/></svg>
        </div>
        <p class="dish">Sichuan mapo tofu, from scratch</p>
        <div class="stats">⏱ 30 min &nbsp;·&nbsp; <b>52</b> made it</div>
        <span class="made-pill">💬 18 tips shared</span>
      </div>

    </div>
  </div>
</section>

<!-- ================= HOW IT WORKS ================= -->
<section class="how">
  <div class="wrap">
    <div class="section-head" style="margin:0 auto 54px; text-align:center;">
      <span class="section-kicker" style="display:block;">How it works</span>
      <h2 class="section-title">Three things happen.<br>That's <em>the whole loop.</em></h2>
    </div>
    <div class="how-grid">

      <div class="how-card">
        <span class="how-step">One</span>
        <div class="how-icon" style="background:rgba(216,90,48,0.12);">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12c0-4 3-7 7-7s7 3 7 7-3 7-7 7" stroke="#D85A30" stroke-width="1.8" stroke-linecap="round"/><path d="M9 19l-2 2M15 19l2 2" stroke="#D85A30" stroke-width="1.8" stroke-linecap="round"/></svg>
        </div>
        <h3>Post your recipe</h3>
        <p>Film it, write the ingredients, set the cook time. It lands on the feed looking like a real dinner invite, not a database entry.</p>
      </div>

      <div class="how-card">
        <span class="how-step">Two</span>
        <div class="how-icon" style="background:rgba(29,158,117,0.12);">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 12l6 6L20 6" stroke="#1D9E75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
        <h3>Someone makes it</h3>
        <p>They tap "Made it?" and post their version — nailed it, almost, or their own twist. Every reply is a real cooking session, not a comment.</p>
      </div>

      <div class="how-card">
        <span class="how-step">Three</span>
        <div class="how-icon" style="background:rgba(250,199,117,0.22);">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 21h8M12 17v4M7 4h10v4a5 5 0 01-10 0V4z" stroke="#BA7517" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
        <h3>The recipe grows up</h3>
        <p>Forty-seven versions later, one dish has a whole community behind it. That thread is more useful than any star rating.</p>
      </div>

    </div>
  </div>
</section>

<!-- ================= CHALLENGES (full section) ================= -->
<section class="challenges-section" id="challenges">
  <div class="wrap">

    <div class="section-head" style="margin:0 auto; text-align:center; max-width:680px;">
      <span class="section-kicker" style="display:block;">The challenges</span>
      <h2 class="section-title">Three days.<br>Three ingredients.<br>One <em>winner.</em></h2>
      <p class="section-desc">Creators set the rules — the ingredients, the cuisine, the clock. You cook. They personally pick the winner. No algorithm decides who's best at dinner.</p>
    </div>

    <!-- step-by-step explainer -->
    <div class="challenge-steps">
      <div class="cstep-card">
        <div class="cstep-num">1</div>
        <h4>A creator posts a challenge</h4>
        <p>They pick the required ingredients, the cuisine, a max cook time, and how long entries stay open — usually 3 days.</p>
      </div>
      <div class="cstep-card">
        <div class="cstep-num">2</div>
        <h4>The community cooks</h4>
        <p>Anyone can enter. Film your dish, tag the challenge, and tell the story behind your version — twist, technique, or straight-up nailed it.</p>
      </div>
      <div class="cstep-card">
        <div class="cstep-num">3</div>
        <h4>The creator crowns a winner</h4>
        <p>Not the most likes — the best dish, judged by a real person who actually cooks. The winner gets a badge that lives on their profile for good.</p>
      </div>
    </div>

    <!-- live challenge spotlight -->
    <div class="challenge-banner">
      <div>
        <span class="eyebrow"><span class="dot"></span>Hosted by real creators</span>
        <h3>This week:<br><em>"Show me your technique."</em></h3>
        <p>Maria K. is judging 84 entries of her 3-ingredient pasta challenge. Closes in 47 hours — there's still time to pull up a chair.</p>
        <div class="challenge-list">
          <div class="challenge-list-item">
            <div class="check-circle"><svg width="11" height="11" viewBox="0 0 12 12"><path d="M2 6l3 3 5-6" stroke="#FAC775" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
            <p>A real person judges, not a like count</p>
          </div>
          <div class="challenge-list-item">
            <div class="check-circle"><svg width="11" height="11" viewBox="0 0 12 12"><path d="M2 6l3 3 5-6" stroke="#FAC775" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
            <p>Winner badges live on your profile, permanently</p>
          </div>
          <div class="challenge-list-item">
            <div class="check-circle"><svg width="11" height="11" viewBox="0 0 12 12"><path d="M2 6l3 3 5-6" stroke="#FAC775" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
            <p>New challenge dropping every few days</p>
          </div>
        </div>
        <a href="#get" class="btn-primary">Enter this challenge</a>
      </div>

      <div class="challenge-visual">
        <span class="live-pill"><span class="dot"></span>LIVE NOW</span>
        <p class="ctitle">Pasta with 3 ingredients only</p>
        <div class="ingredient-chips">
          <span>🍝 Pasta</span><span>🥚 Eggs</span><span>🧀 Pecorino</span>
        </div>
        <div class="cv-stats">
          <div class="cv-stat"><b>84</b><span>entries</span></div>
          <div class="cv-stat"><b>30m</b><span>max cook</span></div>
          <div class="cv-stat"><b>47h</b><span>remaining</span></div>
        </div>
      </div>
    </div>

    <!-- last winner board -->
    <div class="winner-board">
      <div class="winner-board-left">
        <div class="winner-avatar"><span class="winner-crown">🏆</span></div>
        <div>
          <h5>Priya R. won last week's challenge</h5>
          <p>Beat <span>52 other entries</span> with a smoked-paprika twist on James's one-pan BBQ flatbread.</p>
        </div>
      </div>
      <a href="#get" class="winner-cta">See the winning dish</a>
    </div>

  </div>
</section>

<!-- ================= FOUNDING CREATOR ================= -->
<section class="creator-section" id="creators">
  <div class="wrap creator-grid">

    <div class="cert-mock">
      <p class="ctop">Nemonto · Founding Creator</p>
      <svg class="cbowl" width="64" height="64" viewBox="0 0 100 100">
        <ellipse cx="50" cy="74" rx="30" ry="6" fill="#993C1D" opacity="0.5"/>
        <path d="M20 50 Q20 78 50 78 Q80 78 80 50 Z" fill="#D85A30"/>
        <path d="M18 47 Q18 53 23 53 L77 53 Q82 53 82 47 Q82 38 50 38 Q18 38 18 47 Z" fill="#FAECE7"/>
        <path d="M34 30 Q31 22 34 13" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
        <path d="M50 27 Q47 19 50 10" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
        <path d="M66 30 Q63 22 66 13" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
      </svg>
      <p class="cname">Maria K.</p>
      <p class="csub">was among the first 20 creators to join<br>Dinner invitation. Accepted.</p>
      <span class="cbadge">Founding Creator #004</span>
    </div>

    <div class="creator-copy">
      <span class="section-kicker">For creators</span>
      <h2 class="section-title">Bring your followers.<br>Keep <em>the recognition.</em></h2>
      <p class="section-desc">The first 20 creators in every city get a permanent badge, lifetime Pro access, and first right to host challenges. Not a partnership deck — just a seat saved for you.</p>
      <ul>
        <li><span>🏅</span><span><b>Permanent founding badge</b> — visible on your profile forever, even at 5 million users.</span></li>
        <li><span>♾</span><span><b>Free Pro, for life</b> — grandfathered in before we ever charge a cent.</span></li>
        <li><span>⚑</span><span><b>First right to host challenges</b> — you help define what a Nemonto challenge feels like.</span></li>
        <li><span>📣</span><span><b>Weekly spotlight</b> — we promote you on our own channels, not the other way around.</span></li>
      </ul>
      <a href="#get" class="btn-ghost">Apply as a founding creator</a>
    </div>

  </div>
</section>

<!-- ================= TESTIMONIALS ================= -->
<section class="quote-section" id="stories">
  <div class="wrap">
    <div class="section-head" style="margin:0 auto 48px; text-align:center; max-width:640px;">
      <span class="section-kicker" style="display:block;">From the table</span>
      <h2 class="section-title">People are actually <em>cooking.</em></h2>
    </div>
    <div class="quote-grid">

      <div class="quote-card">
        <p class="q">"I posted my grandmother's recipe and within a week, six strangers had cooked it and told me their version. That never happens on Instagram."</p>
        <div class="qwho"><div class="avatar" style="background:#F0997B"></div><div><p class="name">Maria K.</p><p class="tag">Founding Creator</p></div></div>
      </div>

      <div class="quote-card">
        <p class="q">"I won a challenge against eighty other entries and the host actually messaged me herself. It felt like winning something real."</p>
        <div class="qwho"><div class="avatar" style="background:#9FE1CB"></div><div><p class="name">Priya R.</p><p class="tag">Challenge Winner</p></div></div>
      </div>

      <div class="quote-card">
        <p class="q">"My feed isn't full of ads for kitchen gadgets I don't need. It's just food people actually made, in their actual kitchens."</p>
        <div class="qwho"><div class="avatar" style="background:#AFA9EC"></div><div><p class="name">James L.</p><p class="tag">Home Cook</p></div></div>
      </div>

    </div>
  </div>
</section>

<!-- ================= FINAL CTA ================= -->
<section class="final-cta" id="get">
  <div class="wrap">
    <h2>Dinner's ready.<br><em>Pull up a chair.</em></h2>
    <p>Free to join. No algorithm deciding what you see. Just recipes, made by people, for people.</p>
    <div class="store-row">
      <a href="#" class="store-btn">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M16.5 1.5c.1 1.2-.4 2.4-1.1 3.2-.8.9-2 1.6-3.2 1.5-.1-1.1.4-2.4 1.1-3.2.8-.9 2.1-1.6 3.2-1.5z" fill="#FAECE7"/><path d="M19.8 17.6c-.6 1.3-.9 1.9-1.6 3-1.1 1.6-2.6 3.6-4.5 3.6-1.7 0-2.1-1.1-4.4-1.1-2.3 0-2.8 1.1-4.5 1.1-1.9 0-3.3-1.8-4.4-3.4C-1.9 17 -1.4 9.8 3 7.4c1.1-.6 2.3-1 3.5-1 1.4 0 2.7.7 3.6.7.9 0 2-.7 3.7-.7 1 0 3.1.3 4.6 2.5-3.4 2-2.7 6.3 1.4 8.7z" fill="#FAECE7"/></svg>
        <span><small>Download on the</small><strong>App Store</strong></span>
      </a>
      <a href="#" class="store-btn">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3.6 2.6c-.4.2-.6.6-.6 1.1v16.6c0 .5.2.9.6 1.1l9.2-9.4-9.2-9.4z" fill="#FAECE7"/><path d="M16.3 12l3.5-2-2.7-2.8-3.9 4 3.9 4 2.7-2.8-3.5-2.4z" fill="#FAC775"/></svg>
        <span><small>Get it on</small><strong>Google Play</strong></span>
      </a>
    </div>
  </div>
</section>

<!-- ================= FOOTER ================= -->
<footer>
  <div class="wrap">
    <div class="footer-grid">
      <div>
        <div class="footer-logo"><img src="/image/nemonto-logo.png" alt="Nemonto" /></div>
        <p class="tag">A Bengali word for dinner invitation. A place to cook, share, and gather — one recipe at a time.</p>
      </div>
      <div class="footer-col">
        <h4>Product</h4>
        <a href="#table">The feed</a>
        <a href="#challenges">Challenges</a>
        <a href="#creators">For creators</a>
        <a href="#get">Download</a>
      </div>
      <div class="footer-col">
        <h4>Company</h4>
        <a href="#">About</a>
        <a href="#">Careers</a>
        <a href="#">Press</a>
        <a href="#">Contact</a>
      </div>
      <div class="footer-col">
        <h4>Legal</h4>
        <a href="#">Privacy</a>
        <a href="#">Terms</a>
        <a href="#">Community guidelines</a>
      </div>
    </div>
    <div class="footer-bottom">
      <span>© 2026 Nemonto. Made with appetite in New York.</span>
      <span>You're invited to the table.</span>
    </div>
  </div>
</footer>

</body>
</html>

`;
